<template>
  <div id="app">
    <div
      v-if="hasAccess"
      class="nav"
    >
      <router-link class='menu' to="/">My Account</router-link>
      <router-link class='menu' to="/change-password">Change Password</router-link> <br>
      <router-link class='menu' to="/edit-profile">Edit Profile</router-link>
      <a class='menu' v-if="oidcIsAuthenticated" href @click.prevent="signOut">Sign out</a>
    </div>
    <div v-else class="ajax-loader">
       <img src="/ajax-loader.gif" alt="loading" />
    </div>
    <div class="body-main">
      <router-view/>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

var cognitoLogoutUrl = process.env.VUE_APP_AUTH_BASE_URL + '/logout?client_id=' + process.env.VUE_APP_AUTH_CLIENT_ID + '&logout_uri=' + encodeURI(process.env.VUE_APP_AUTH_REDIRECT_URI)
export default {
  name: 'App',
  computed: {
    ...mapGetters('oidcStore', [
      'oidcIsAuthenticated'
    ]),
    hasAccess: function () {
      return this.oidcIsAuthenticated || this.$route.meta.isPublic
    }
  },
  methods: {
    ...mapActions('oidcStore', [
      'authenticateOidcPopup',
      'removeOidcUser'
    ]),
    userLoaded: function (e) {
      // console.log('I am listening to the user loaded event in vuex-oidc', e.detail)
    },
    oidcError: function (e) {
      // console.log('I am listening to the oidc error event in vuex-oidc', e.detail)
    },
    signOut: function () {
      this.removeOidcUser().then(() => {
        window.location.assign(cognitoLogoutUrl)
      })
    }
  },
  mounted () {
    window.addEventListener('vuexoidc:userLoaded', this.userLoaded)
    window.addEventListener('vuexoidc:oidcError', this.oidcError)
  },
  destroyed () {
    window.removeEventListener('vuexoidc:userLoaded', this.userLoaded)
    window.removeEventListener('vuexoidc:oidcError', this.oidcError)
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.ajax-loader {
  margin: 7em auto 3em;
}
.nav {
  background-color: #B03400;
  overflow: hidden;
  justify-content: center;
  display: flex;
  width: 100%; /* Full width */
}
.nav > div {
  display: flex;
  flex-basis: calc(50% - 40px);
  justify-content: center;
  flex-direction: column;
}
/* Style the links inside the navigation bar */
.menu {
  border: 1pt;
  border-color: #2c3e50;
  display: inline;
  color: #f2f2f2;
  text-align: center;
  padding: 14px 16px;
  text-decoration: none;
  font-size: 10pt;
}

/* Change the color of links on hover */
.menu:hover {
  background-color: #E88000;
  color: black;
}

/* Add a color to the active/current link */
.menu.active {
  background-color: #4CAF50;
  color: white;
}
/* Add a black background color to the top navigation
 */

/* Code for Password  */
html { box-sizing: border-box; }

*, *:before, *:after { box-sizing: inherit; }

html, body {
  height: 100%;
  width: 100%;
  margin: 0;
  padding: 0;
}

body {
  /* font-family: 'Open Sans', sans-serif; */
  display: block;
  background: #d4ac94;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.body-main {
  display: block;
  max-width: calc( 400px + 4em );
  margin: 2em auto;
  padding: 0 2em;
}

h2 {
  text-align: center;
  color: #FFF;
  font-weight: 400;
}

ul {
  padding-left: 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

li {
  margin-bottom: 8px;
  color: #525f7f;
  position: relative;
}

li:before {
  content: "";
  width: 0%; height: 2px;
  background: #6bbdd6;
  position: absolute;
  left: 0; top: 50%;
  display: block;
  transition: all .6s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

#app { min-width: 400px; }

/* Password Input --------- */

.input_container {
  position: relative;
  padding: 30px;
  box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);
  border-radius: 6px;
  background: #FFF;
}

.input_container p {
  text-align: initial;
}

.input_container div {
  margin-bottom: 2.5em;
}

input[type="password"] {
  line-height: 1.5;
  display: block;
  color: rgba(136, 152, 170, 1);
  font-weight: 300;
  width: 100%;
  height: calc(2.75rem + 2px);
  padding: .625rem .75rem;
  border-radius: .25rem;
  background-color: #fff;
  transition: border-color .4s ease;
  border: 1px solid #cad1d7;
  outline: 0;
}

input[type="password"]:focus {
  border-color: rgba(50, 151, 211, .45);
}

/* Checkmark & Strikethrough --------- */

.is_valid { color: rgba(136, 152, 170, 0.8); }
.is_valid:before { width: 100%; }

.checkmark_container {
  border-radius: 50%;
  position: absolute;
  top: -15px; right: -15px;
  background: #AAC8D1;
  width: 50px; height: 50px;
  visibility: hidden;
  opacity: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: opacity .4s ease;
}

.show_checkmark {
  visibility: visible;
  opacity: 1;
}

.checkmark {
  width: 100%;
  height: 100%;
  fill: none;
  stroke: white;
  stroke-width: 15;
  stroke-linecap: round;
  stroke-dasharray: 180;
  stroke-dashoffset: 180;
}

.submitPass{
  margin-top: 20pt;
  background: #AAC8D1;
  border-radius: 10px;
  /* color: white; */
  height: 50px;
  width: 100px;
  font: bold 15px arial, sans-serif;
  text-shadow:none;
  text-align: center;
}

.submit_container{
  visibility: hidden;
  opacity: 0;
  /* display: flex; */
  justify-content: center;
  align-items: center;
  /* transition: opacity .4s ease; */
}

.show_submit {
  visibility: visible;
  opacity: 1;
}

.checked { animation: draw 0.5s ease forwards; }

@keyframes draw {
  to { stroke-dashoffset: 0; }
}
</style>
